const generateGuid = () => {
  if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
    const buffer = new Uint8Array(16);
    crypto.getRandomValues(buffer);

    // oxlint-disable-next-line no-bitwise
    buffer[6] = (buffer[6] & 0x0f) | 0x40;
    // oxlint-disable-next-line no-bitwise
    buffer[8] = (buffer[8] & 0x3f) | 0x80;

    // Convert to hex string with proper formatting
    return Array.from(buffer)
      .map((b) => b.toString(16).padStart(2, '0'))
      .join('')
      .replace(/(.{8})(.{4})(.{4})(.{4})(.{12})/, '$1-$2-$3-$4-$5');
  }

  // Fallback for older browsers
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = Math.floor(Math.random() * 16);
    // oxlint-disable-next-line no-bitwise
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

export default generateGuid;
